
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import eventBus from '../plugins/eventBus'
import router from '../router'
import { ItemCartModel } from '@/store/models/ItemCartModel'
import { envConfiguration } from '@/plugins/globalStaticDatas'

@Component
export default class CartItem extends Vue {
  @Prop(Object) record: ItemCartModel
  @Prop(Number) index: any
  @Prop({ default: 'modal', type: String }) cartView: string

  // itemValue: number = this.record.quantity * this.record.price
  counter: any = 1
  disableBtn: boolean
  envConfigurations: any = envConfiguration

  goto(id: string) {
    router.push({ name: 'item', params: { id: id } }).catch(() => {})
  }
  updateStore() {
    eventBus.$emit('cart-item:updated-quantity', {
      quantity: (this.counter = /^[0,-]/.test(this.counter) ? 1 : this.counter),
      itemId: this.record.productId,
    })
  }
  productName(productName: string) {
    if (!productName) return 'Nuk Ka Emër'
    if (productName.split('').length > 38) {
      return `${productName.substring(0, 30)}...`
    }
    return productName
  }
  removeItem() {
    this.$emit('cart-item:remove')
  }
  incrementValue() {
    this.counter++
  }
  decrementValue() {
    this.counter--
    if (this.counter <= 1) {
      this.disableBtn = true
    }
  }

  mounted() {
    this.counter = this.record.quantity
    this.disableBtn = this.record.quantity <= 1
  }

  @Watch('counter')
  onCounterChange(from: any, to: any) {
    this.updateStore()
  }
}
